/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Attendee_Organizer_InlineInputs */



/**
* | output |
* | --- |
* | "{name} (organiser)" |
*
* @param {Meeting_Attendee_Organizer_InlineInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_attendee_organizer_inline = /** @type {((inputs: Meeting_Attendee_Organizer_InlineInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Attendee_Organizer_InlineInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} (organisator)`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} (organisateur)`)
	return /** @type {LocalizedString} */ (`${i?.name} (organiser)`)
});